export const navfunc = ({ isActive, isPending, isTransitioning }) => {
    return {
        color: isActive ? "white" : "#adb5bd",
        // backgroundColor: isActive ? "#0f3e8a" : ""
    };
}

export const navLinkHeaderStylefunc = ({ isActive, isPending, isTransitioning }) => {
    return {
        color: isActive ? "white" : "",
        backgroundColor: isActive ? "#0f3e8a" : ""
    };
}